import React from 'react';

const SvgCv = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CV_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CV_svg__b" fill="#fff">
        <use xlinkHref="#CV_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CV_svg__a" />
      <path
        fill="#0C49AE"
        mask="url(#CV_svg__b)"
        d="M0 0h28v10.667H0zM0 14.667h28V20H0z"
      />
      <path fill="#FFF" mask="url(#CV_svg__b)" d="M0 10.667h28v4H0z" />
      <path fill="#CD232E" mask="url(#CV_svg__b)" d="M0 12h28v1.333H0z" />
      <path
        d="M10.667 16.667a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
        stroke="#F7D035"
        strokeWidth={1.333}
        strokeLinecap="round"
        strokeDasharray="0.6666666666666666 2"
        mask="url(#CV_svg__b)"
      />
    </g>
  </svg>
);

export default SvgCv;
